import { API_BASE } from '../config'

export async function adminApi<T = unknown>(
  path: string,
  init?: RequestInit & { json?: unknown; formData?: FormData }
): Promise<{ res: Response; data: T }> {
  const { json, formData, headers: h, ...rest } = init || {}
  const headers = new Headers(h)
  let body = rest.body
  if (formData) {
    body = formData
  } else if (json !== undefined) {
    headers.set('Content-Type', 'application/json')
    body = JSON.stringify(json)
  }
  const res = await fetch(`${API_BASE}${path}`, {
    credentials: 'include',
    ...rest,
    headers,
    body,
  })
  const data = (await res.json().catch(() => ({}))) as T
  return { res, data }
}
